<template>
  <!-- 个性化名称 -->
  <div class="titleStyle">
    <div class="ts_wap">
      <div></div>
      <div>{{CHN}}</div>
      <div>{{USA}}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    CHN: {
      type: String,
      default: ""
    },
    USA: {
      type: String,
      default: ""
    }
  },
  name: "home",
  data() {
    return {};
  }
};
</script>

<style scoped lang="less">
.ts_wap div:nth-child(3) {
  width: 100%;
  height: 84px;
  font-size: 60px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #f3f3f3;
  line-height: 84px;
  position: absolute;
  text-align: center;
  top:30px;
}
.ts_wap div:nth-child(2) {
  width: 100%;
  height: 40px;
  font-size: 40px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(51, 51, 51, 1);
  line-height: 40px;
  text-align: center;
  position: absolute;
  text-align: center;
  top:30px;
  z-index: 2;
}
.ts_wap div:nth-child(1) {
  width: 80px;
  height: 8px;
  background: rgba(80, 174, 254, 1);
  margin: 0 auto;
}
.ts_wap {
  width: 100%;
  height: 105px;
  margin: 40px auto;
  position: relative;
}
</style>




// WEBPACK FOOTER //
// src/components/common/titleStyle/titleStyle.vue